import { createFileRoute, Outlet } from '@tanstack/react-router';
import { authGuardRoute } from '@/features/authenticate';
import { LoadingScreen } from '@drisk-ai/ui';

export const Route = createFileRoute('/_public')({
  beforeLoad: () => authGuardRoute({ isPrivate: false }),
  component: RouteComponent,
  pendingComponent: () => <LoadingScreen />,
});

function RouteComponent() {
  return <Outlet />;
}
